<div class="title">
    <ng-content select="[title]"></ng-content>
</div>
<div class="navigation-sheet" [ngClass]="{'hide-footer': whiteLabel }">
    <ng-content select="[card]"></ng-content>
</div>
